import { useMemo } from 'react';
import { relative as relativePath, isAbsolute } from 'path';
import { useRouter } from 'next/router';

export function buildPath(url: string) {
  try {
    return new URL(url, window.location.origin).pathname.toLowerCase();
  } catch {
    return null;
  }
}

function isWithinBasePath(basePath: string, path: string): boolean {
  const relative = relativePath(basePath, path);
  return !relative.startsWith('..') && !isAbsolute(relative);
}

export function findClosestBasePathIndex(path: string, basePaths: string[]): number | null {
  let index: number | null = null;
  const isCloserBasePath = (basePath: string) => !index || basePath.length > basePaths[index].length;

  basePaths.forEach((basePath, i) => (index = isWithinBasePath(basePath, path) && isCloserBasePath(basePath) ? i : index));

  return index;
}

export function useClosestBaseUrlIndex(baseUrls?: string[]): number | null {
  const path = buildPath(useRouter().asPath.toLowerCase().split('?')[0]);
  return useMemo(
    () => (path !== null ? findClosestBasePathIndex(path, (baseUrls ?? []).map(buildPath).filter((p) => p !== null) as string[]) : null),
    [path, baseUrls]
  );
}
